import { CreateOrder } from 'components/Pages/Scheduling/CreationForm';
import { Scaffold } from 'layouts';
// import { ListOrders } from 'components/Pages/Scheduling/PaginatedOrders';
import { SchedulingLayout } from 'layouts/Scheduling';

export const CreateOrderPage: React.FC = () => {
  return (
    <Scaffold>
      <SchedulingLayout>
        <CreateOrder />
      </SchedulingLayout>
    </Scaffold>
  );
};
